<section>
  <h1 class="title">{{ 'PROFILE.MY_TEAMS_ACTIVITY_BLOCK_TITLE' | translate }}</h1>

  <div class="team-activity_content">
    <app-gamification-events-list [memberId]="teamId"></app-gamification-events-list>
  </div>
</section>
